export enum AppRoute {
  Root = "",
  Investor = "investor",
}
